import { StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';

import { CardLayout, UsernameFormInput, Button, spacing } from '@pletly/ui';
import { withTranslation } from '../../../locales/hoc';
import { useCareReceiverImport } from './components/useCareReceiverImport';
import { RootStackScreenProps } from '../../../navigation';

type Props = RootStackScreenProps<'ImportOrganisationMember'>;
const ImportCareRecipient = ({
	route: {
		params: { organisationUuid },
	},
}: Props) => {
	const { t } = useTranslation();
	const { formMethods, loading, onSubmit } = useCareReceiverImport(organisationUuid);

	return (
		<CardLayout
			title={t('import-care-recipient')}
			subtitle={t(
				'enter-the-care-recipients-unique-username-to-send-an-import-request-to-the-account-owner',
			)}
		>
			<FormProvider {...formMethods}>
				<View style={styles.container}>
					<UsernameFormInput transform={undefined} />
					<Button variant="filled" color="primary" onPress={onSubmit} loading={loading}>
						{t('request-ownership')}
					</Button>
				</View>
			</FormProvider>
		</CardLayout>
	);
};

const styles = StyleSheet.create({
	container: {
		rowGap: spacing(4),
		marginVertical: spacing(2),
	},
});

export default withTranslation(ImportCareRecipient);
